import Axios from "axios";
import { PATH } from "../../envs/core";
import { historic } from "../../constants/api";

export const getResultOrigin = (
  year,
  type,
  electionNumber,
  placeId = "C108"
) => {
  return Axios.get(
    `${PATH}${historic}/${year}/${type}/${electionNumber}/${placeId}`
  ).then(({ data }) => data);
};
